import { useTranslation } from "react-i18next";
import { appPaths } from "../../../shared/routing/appPaths";
import { useWorkspace } from "../../../shell/workspace";
import AppButton from "../../../ui/buttons/AppButton";

/**
 * The Run's graph, opened beside the Run (WD-4, D-1), from the Run's header where the Workflow it follows is named
 * too (F149: findable from the Run). It is named as the Run's graph, the name the graph has everywhere, so it is not
 * taken for the Workflow's (F131).
 */
export default function RunGraphButton({ threadId }: { readonly threadId: string }) {
  const { t } = useTranslation();
  const workspace = useWorkspace();
  return (
    <AppButton variant="secondary" size="xs" title={t("threads.steps.openRun")} onClick={() => { workspace.open(appPaths.runGraph(threadId), { placement: "beside" }); }}>
      {t("threads.runGraph.label")}
    </AppButton>
  );
}
